<template>
    <div class="park-detail" >
        <div class="box" >
			<ul class="header"  >
				<li class="title" >{{title}}基本信息</li>
				<li class="btn" v-on:click="$parent.isShowPark(false)"  >X</li>
			</ul>
			
			<div class="footer" >
				<div v-if="title != '张江中区'" >
					<div>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{resData.detail}}</div>
					<ul class="listDetail" >
						<li v-for="(item,index) in resData.listDetail " :key="index+'1'" style="width:100%;overflow:hidden;background:" >
							<p class="title" style="color:#000"  >{{item.name}}</p><span class="detail" >{{item.detail}} </span>
						</li>
					</ul>
				</div>
				<div v-else style="margin-top:30px;" >
					<div>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{resData.detailTop}}</div>
					<br/>
					<div>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{resData.detailAdd}}</div>
					<br/>
					<div>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{resData.detailCenter}}</div>
					<br/>
					<div>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{resData.detailBottom}}</div>
				</div>
				
			</div>
		</div>
    </div>
</template>
<script>
    export default {
		props:{
			title:String
		},
        data(){
            return {
				data:[{
						title:'人工智能岛',
						detail:'人工智能岛，企业总部的梦想家园，毗邻川杨河及张江中区未来公园，依林而建，傍水而居，实为嘈杂城市钢筋水泥中的一篇科技绿洲。有水的地方就有了活力，有水的地方就有了灵性。来这里，激起一场科技与灵感的碰撞，来这里，造就一坐生机勃勃的科学城。张江中区科创园，科技内涵域产城融合的典范之作。',
						listDetail:[
							{name:'租赁总面积',detail:'10.2万平方米'},
							{name:'楼板载荷',detail:'350kg/m2'},
							{name:'建筑层数',detail:'A区6层，B区3-4层，C区4层'},
							{name:'标准层高',detail:'A区4.5m，B区4.2m'},
							{name:'客用电梯',detail:'A区4部客梯，B区1部客梯'},
							{name:'空调系统',detail:'集中供能'},
							{name:'停车位',detail:'1000个'},
							{name:'地址',detail:'上海市浦东新区上科路366号'},
							{name:'交通',detail:'13号线、园区班车'},
							{name:'建筑户型1',detail:'21'},
							{name:'建筑户型2',detail:'1 ~ 4'},
							{name:'建筑户型3',detail:'5 ~ 20'},
						]
					},

					{
						title:'研创园',
						detail:'研创园以打造中国研发创新高地为目标，集聚各类研发机构、创新服务平台和科研人才，营造资源共享、信息通达、各学科交叉融合的创新创业环境，为入驻企业打造研发资源聚集，创新氛围浓厚的总部级生态商务群落。',
						listDetail:[
							{name:'租赁总面积',detail:'5.8 万平方米'},
							{name:'楼板载荷',detail:'300kg/m2'},
							{name:'建筑层数',detail:'小高层共11层，小独栋4-5层'},
							{name:'标准层高',detail:'小高层4.5米，小独栋3.9米'},
							{name:'客用电梯',detail:'采用通力品牌，小独栋每幢1部，小高层4部'},
							{name:'空调系统',detail:'小高层集中供能，小独栋预留VRV机位'},
							{name:'停车位',detail:'565个'},
							{name:'地址',detail:'上海市浦东新区学林路36弄'},
							{name:'交通',detail:'1地铁13号线，园区班车'},
							{name:'建筑户型1',detail:'1，2'},
							{name:'建筑户型2',detail:'4，10'},
							{name:'建筑户型3',detail:'3，7，11'},
							{name:'建筑户型4',detail:'5，6，8，9'},
							{name:'建筑户型5',detail:'12，13，14'},
							{name:'建筑户型6',detail:'15，16，17，18，19'},

						]
					},
					{
						title:'国际人才港',
						detail:'国际人才港定位于高端的创新领地，以金融科技产业为核心，聚集高端产业机构，搭建高效运营机制，构筑资源整合大平台，与全球金融企业一起引领行业风向，开启科技金融新时代。',
						listDetail:[
							{name:'租赁总面积',detail:'5.4万平方米'},
							{name:'楼板载荷',detail:'350kg/m2'},
							{name:'建筑层数',detail:'小高层共13层，小独栋4-5层'},
							{name:'标准层高',detail:'小高层4.1米，小独栋3.9米'},
							{name:'客用电梯',detail:'采用通力品牌，小独栋每幢1部，小高层3部'},
							{name:'空调系统',detail:'集中供能'},
							{name:'停车位',detail:'500个'},
							{name:'地址',detail:'上海市浦东新区环科路999弄'},
							{name:'交通',detail:'13号线、园区接驳班车'},
							{name:'建筑户型1',detail:'9，10'},
							{name:'建筑户型2',detail:'2，3，5，6，7，8'},
							{name:'建筑户型3',detail:'25，23，22，21，18，17，16，15，12'},
						]
					},
					{
						title:'张江中区基本信息',
						detailTop:'张江高科技园区，被誉为中国硅谷。成立于1992年7月，位于上海浦东新区中南部，是中国国家级高新技术园区，与陆家嘴、金桥和外高桥开发区同为上海浦东新区四个重点开发区域。',
						detailAdd:'经过近二十年的开发，园区建筑了生物医药创新链、集成电路产业链和软件产业链的框架。',
						detailCenter:'园区有国家上海生物医药科技产业基地、国家信息产业基地、国家集成电路产业基地、国家半导体照明产业基地、国家863信息安全成果产业化（东部）基地、国家软件产业基地、国家软件出口基地、国家文化产业示范基地、国家网游动漫产业发展基地等多个国家级基地。键有国家火炬创业园、国家留学人员创业园。',
						detailBottom:'张江高科技园区正向着世界级高科技园区的愿景目标阔步前进。',
						listDetail:[

						]
					}]
				
            }
        },
        mounted(){
			// console.log(this.title,'title111')
        },

        methods:{
			
        },
        components:{

		},
		computed:{
			resData:function(){
				if(this.title == '人工智能岛'){
					return this.data[0]
				} else if(this.title == '研创园') {
					return this.data[1]
				} else if(this.title == '国际人才港'){
					return this.data[2]
				} else{
					return this.data[3]
				}
				
			}
		}
    }
</script>
<style scoped lang="scss" >
	.park-detail{
		position: fixed;
		z-index: 111;
		width:100%;
		height:100%;
		background:rgba(0,0,0,0.4);
		.listDetail{
			li:nth-child(odd){
				background:#fff5f2
			}
			li{
				padding:2px;
				// display:flex;
			}
            line-height:2;
            padding:10px;
			padding-left:20px;
            .title{
                color:#666;
                font-size:18px;
				display:block;
                width:35%;
                float:left;
                // text-align: right;
            }
            .detail{
                color:#555;
                font-size:18px;
                width:65%;
                display:block;
                float:left;
            }
        }
		.box{
			border-radius:8px;
			width:700px;
			height:600px;
			background:rgba(255,255,255,1);
			position: absolute;
			top:0;
			bottom:0;
			left:0;
			right:0;
			margin:auto;
			.header{
				width:700px;
				border-top-left-radius: 5px;
				border-top-right-radius: 5px;
				height:80px;
				position: fixed;
				z-index:100;
				background:rgba(243,243,243,1);
				color:#383838;
				font-weight: 800;
				display:flex;
				padding:20px;
				box-sizing: border-box;
				li{
					line-height: 1.5;
				}
				.title{
					font-size:26px;
					flex:1;
				}
				.btn{
					color:#999;
					font-size:20px;
					cursor: pointer;
				}
			}
			.footer{
				height:600px;
				overflow: hidden;
				overflow: auto;
				-webkit-overflow-scrolling: touch;
				color:#383838;
				padding:20px;
				padding-top:100px;
				box-sizing: border-box;
				line-height:1.6;
			}
		}
		@media screen and (max-width: 800px) {
		.listDetail{
			padding-left:10px;
		}
		.box {

			.header{
				width:95%;
				height:55px;
				padding:10px;
				li{
					line-height:35px;
				}
				.title{
					font-size:20px;
				}
			}
			.footer{
				height: 300px;
				padding:10px;
				padding-top:75px;
			}
			width:95%;
			height:50%;
		}
}
	}
</style>




// WEBPACK FOOTER //
// src/commonComponents/ParkDetail.vue